<template>
  <div v-if="timeUpbox===indexShow">
    <div
      class="flight-time_upbox"
      :style="{'top':listLength>1&&timeUpboxHeight>71?
                (timeUpboxHeight/2 - (listLength*25)) +'px':listLength>1?'-'+(timeUpboxHeight/2 - 25) +'px':
                timeUpboxHeight/2 - 25 +'px'}"
    >
      <div class="fligth-time_item" v-for="(item,index) in detailList" :key="index">
        <i>{{item.segmentType==1?'去':'回'}}</i>
        <p>{{item.flightNo}} {{item.depCityName}}({{item.depCityCode}}) -- {{item.arrCityName}}({{item.arrCityCode}}) {{item.depDate}}/{{item.depTime}}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    listLength: Number,
    timeUpboxHeight: Number,
    detailList: Array,
    timeUpbox: Number,
    indexShow: Number
  },
  methods: {}
};
</script>
<style lang="less" scoped>
.flight-time_upbox {
  width: 360px;
  border: 1px solid #dfdfdf;
  position: absolute;
  right: -350px;
  z-index: 999;
  overflow-y: auto;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.fligth-time_item {
  padding: 10px 0;
  display: flex;
  width: 95%;
  font-size: 12px;
  margin: auto;
  i {
    display: inline-block;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #237dc9;
    margin-right: 5px;
    color: white;
    font-style: normal;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  p {
    display: flex;
    align-items: center;
  }
}
</style>